/**
 * @description Renders a "badge" - a large circle with text inside
 * @example
 * <div cs-badge="vm.getBadgeValue()" ng-attr-cs-badge-placeholder="{{vm.renderBadgePlaceholder()}}"></div>
 */
;(function () {
  'use strict'

  angular.module('contrast.badge').directive('csBadge', function () {
    'ngInject'

    return {
      restrict: 'A',
      controller: 'csBadgeCtrl',
      controllerAs: 'badgeCtrl',
      templateUrl: 'components/badge/cs-badge.html',
      scope: true,
      bindToController: {
        csBadge: '='
      },
      link: function ($scope, elem, attrs, ctrl) {
        ctrl.csBadgePlaceholder = attrs.csBadgePlaceholder
      }
    }
  })
})()
